import React from 'react'
import './styles.css'

const Switch = ({
                    checked,
                    onChange,
                    label,
                    style = {},
                    disabled = false,
                }) => {

    return (
        <label style={{
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            cursor: disabled ? 'not-allowed' : 'pointer',
            ...style,
        }}
        >
            <div className="switch controller">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={e => onChange(e.target.checked)}
                    disabled={disabled}
                />
                <span className={`slider round ${disabled ? 'disabled' : ''}`}/>
            </div>

            {label}
        </label>

    )
}

export default Switch


// WEBPACK FOOTER //
// ./src/components-new/form/Switch/index.jsx